// @flow
import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Navbar from '../Navbar';
import Sidebar from '../Sidebar';
import Map from '../Map';
import Sync from '../Sync';
import TisPlayer from '../TisPlayer';
import Spinner from '../ui/Spinner';

const useStyles = makeStyles({
    spinner: {
        position: 'fixed'
    }
});

export type Props = $ReadOnly<{
    configFetched: boolean
}>;
function LoggedIn({ configFetched }: Props) {
    const classes = useStyles();

    return (
        <React.Fragment>
            <Sync />

            <Spinner isLoading={!configFetched} spinnerClassName={classes.spinner}>
                {configFetched &&
                    <React.Fragment>
                        <Navbar />
                        <Sidebar />

                        <Map />

                        <TisPlayer />
                    </React.Fragment>
                }
            </Spinner>
        </React.Fragment>
    );
}

export default LoggedIn;